/// <reference types="@types/googlemaps" />
import { Component, OnInit, ViewChild, ViewEncapsulation, Input, Output, EventEmitter, AfterViewInit, AfterViewChecked, ChangeDetectorRef } from '@angular/core';
import { parseNumber } from '@telerik/kendo-intl';

import {searchPointData} from '../../../../../core';
import { ConfirmDialogComponent } from '../../../../../common/component/confirm-dialog/confirm-dialog.component';




@Component({
  selector: 'app-rvrs-search-point-modal',
  templateUrl: './rvrs-search-point-modal.component.html',
  styleUrls: ['./rvrs-search-point-modal.component.scss']
})
export class RvrsSearchPointModalComponent implements OnInit, AfterViewChecked {
  @ViewChild('MapDisplay', { static: false }) MapDisplay: any;
  @ViewChild(ConfirmDialogComponent, { static: false }) confirmDialog:ConfirmDialogComponent
  @Output()  onCloseToParent = new EventEmitter<searchPointData>();
  constructor(private changeDetectorRef:ChangeDetectorRef){

  }
  ngOnInit() {
    this.visible = false;
  }
  ngAfterViewChecked() {
    if (this.MapDisplay && !this.visible) {
      this.visible = true;
      let searchRadius = (this.searchRadiusMiles * 1609.34); //convert from miles to meters

      let zoom = searchRadiusToGoogleZoom(searchRadius);

      let mapOptions = { zoom: zoom };
      //let map = new google.maps.Map(this.MapDisplay.nativeElement, mapOptions);

    }
  }


  init(radius:number){
    this.searchPoint  = {
      Name: '',
      Type: 0,
      PropertyAddress: '',
      geocode: '',
      Latitude:null,
      Longitude:null,
      Radiuskm:0,
      Radius:0
    };
    this.searchType= "Airport";
    this.searchRadiusMiles = radius;
    this.searchTerm = "";
    this.SearchStatus = null;
    this.visible = false;
  }
  visible: boolean;
  showModal: boolean = false;
  showConfirm: boolean = false;
  _searchType: string = "Airport";

  set searchType(stype:string){
    this.searchPoint.Type = (stype=="Airport"?2:1);
    this._searchType = stype;
  }
  get searchType():string{return this._searchType;}

  set searchRadiusMiles(val:number){
    if(val && val!= NaN && val>=1 && val<=20){
      this.searchPoint.Radius = val;
      this.OnMilesSearchChanged();
    }
  }
  get searchRadiusMiles():number{
    return this.searchPoint.Radius;
  }
  blockDelete(event):boolean{
    if(event.key == "Delete" || event.key == "Backspace"){
      event.stopPropagation();
      return false;
    }
    return true;
  }
  checkSearchRadius(event) {
    let nextVal:number =  this.searchRadiusMiles;
    if (event) {
      let val: number = event as number;
      if (val ) {
        nextVal =  val;
      }
    }
    this.searchRadiusMiles = nextVal;
  }

  public searchPoint:searchPointData ;

  MapClicked(newText:string) {
    this.searchTerm = newText;
    this.searchType = "Address";
    this.changeDetectorRef.detectChanges();
  }
  onOk() {
    if (this.validate()) {
      this.searchPoint.Radiuskm = this.searchPoint.Radius * 1.6093472;
      this.onCloseToParent.emit(this.searchPoint);
      this.showModal = false;
    }
  }

  onCancel() {
    this.showModal = false;
  }
  validate():boolean{
    let okay=true;
    if (!this.searchPoint.Name || this.searchPoint.Name.length==0 ) {
      okay  = false;
    }
    if (!this.searchPoint.PropertyAddress || this.searchPoint.PropertyAddress.length==0 ) {
      okay  = false;
    }
    if (!this.searchPoint.geocode || this.searchPoint.geocode.length==0
        || !this.searchPoint.Latitude || this.searchPoint.Latitude==NaN
        || !this.searchPoint.Longitude || this.searchPoint.Longitude==NaN
      ) {
      okay  = false;
    }

    if (!okay) {
      this.confirmDialog.confirm("Please check required fields"
      , "", "Validation").subscribe();
    }
    if(this.searchPoint.Name.length>255 || this.searchPoint.PropertyAddress.length>255){
      okay = false;
      this.confirmDialog.confirm("Name or Address exceeded 255 characters"
      , "", "Validation").subscribe();
    }
    return okay;
  }

  keyup(e){
    var key = e.charCode ? e.charCode : e.keyCode ? e.keyCode : 0;
    if(key == 13)
      this.lookupAddress(e);
  }
  lookupAddress(event) {
    let searchRadius = (this.searchRadiusMiles * 1609.34); //convert from miles to meters

    this.zoom = searchRadiusToGoogleZoom(searchRadius);

    let mapOptions = { zoom: this.zoom };
    this.infowindow = new google.maps.InfoWindow();
    this.map = new google.maps.Map(this.MapDisplay.nativeElement, mapOptions);
    let geocoder:google.maps.Geocoder = new google.maps.Geocoder();
    let type = (this.searchPoint.Type == 1 && this.searchTerm.length>0)?'':' airport';
    let e = geocoder.geocode({ 'address': this.searchTerm + type}, (results, status) => this.process(results, status));
  }

  zoom: number;
  searchTerm: string = "";
  markerList: any[] = [];
  nbrOfResults: number = 0;
  map:google.maps.Map;
  infowindow:google.maps.InfoWindow;
  cityCircle:google.maps.Circle;
  SearchStatus: string = "";
  mapRadius: number;
  setAllMap(map) {
    for (var i = 0; i < this.markerList.length; i++) {
      this.markerList[i].setMap(map);
    }
  }

  clearMarkers() {
    this.setAllMap(null);
  }
  deleteMarkers() {
    this.clearMarkers();
    this.markerList = [];
  }

  checkGeocode($event){
    this.searchPoint.Latitude = null;
    this.searchPoint.Longitude = null;
    this.parseGeocode(this.searchPoint.geocode);
  }
  parseGeocode(str:string){
    let geocode:string = str.trim();
    let arr = geocode.split(',');
    if(arr && arr.length==2 ){
      this.searchPoint.Latitude = parseNumber(arr[0]);
      this.searchPoint.Longitude = parseNumber(arr[1]);
    }
  }
  process(results, status) {
    //console.log(results);
    //console.log(status);
    if (status == google.maps.GeocoderStatus.OK) {
      google.maps.event.addListener(this.map, 'click', (e) => {
        if (e) {
          this.MapClicked(e.latLng.toUrlValue());
        }
      }
      );
      let map = this.map;
      if (results[0]) {

        var mapOptions = { zoom: this.zoom };
        this.deleteMarkers();
        if (this.cityCircle != null) {
          this.cityCircle.setMap(null);
          this.cityCircle = null;
        }

        this.searchPoint.geocode = results[0].geometry.location.toUrlValue();//A + " , " + results[0].geometry.location.F);
        this.parseGeocode(this.searchPoint.geocode);
        var nameForAddress = "";
        var tst = results[0].address_components.every(function (currentValue, index, array) {
          var t = currentValue.long_name;
          if (currentValue.types.indexOf("establishment") >= 0 || currentValue.types.length == 0) {
            nameForAddress = t;
            return false;
          }
          return true;
        });
        this.searchPoint.Name = nameForAddress;

        var toDisplay = results[0].formatted_address;
        if (nameForAddress != "") {
          toDisplay = toDisplay.replace(nameForAddress + ", ", "");
        }
        let searchRadius = (this.searchRadiusMiles * 1609.34); //convert from miles to meters

        this.searchPoint.PropertyAddress = toDisplay;
        this.map.setCenter(results[0].geometry.location);
        var searchPoint = results[0].geometry.location;
        var populationOptions = {
          strokeColor: '#0000FF',
          strokeOpacity: 0.5,
          strokeWeight: 2,
          fillColor: '#0000FF',
          fillOpacity: 0.35,
          map: map,
          center: searchPoint,
          radius: searchRadius,
        };
        this.cityCircle = new google.maps.Circle(populationOptions);
        google.maps.event.addListener(this.cityCircle, 'click', (e) => this.MapClicked(e.latLng.toUrlValue()));

        var marker:google.maps.Marker = new google.maps.Marker({
          map: map,
          position: results[0].geometry.location
        });
        this.markerList.push(marker);
        google.maps.event.addListener(marker, 'click', () => {
          this.infowindow.setContent("Search Center Point\r\n" + searchPoint.toUrlValue());
          this.infowindow.open(map, marker);
        });
        //start
        this.nbrOfResults = 0;
        var request = {
          location: searchPoint,
          radius: searchRadius,
          //types: ['lodging', 'airport'],
          types: ['lodging'],
          //rankBy: google.maps.places.RankBy.DISTANCE, //not compatable with radius search
        };
        var service = new google.maps.places.PlacesService(map);
        var asdf = service.nearbySearch(request, (results, status, pagination) => this.callbackNearbySearch(results, status, pagination));
        //end
      } else {
        this.HandleNoResults("No Results Found");

      }
    } else {
      this.HandleNoResults("Not Found " + status);
    }

  }

  HandleNoResults(msg) {
    this.searchPoint.PropertyAddress = msg;
    this.SearchStatus = "";
    this.searchPoint.Name = "";
    this.searchPoint.geocode = "";
  }
  callbackNearbySearch(results:google.maps.places.PlaceResult[], status:google.maps.places.PlacesServiceStatus, pagination:google.maps.places.PlaceSearchPagination) {
    if (status == google.maps.places.PlacesServiceStatus.OK) {
      for (var i = 0; i < results.length; i++) {
        this.createMarker(results[i]);
        this.nbrOfResults++;
      }
    }
    if (pagination.hasNextPage) {
      console.log('Updating Google search for lodging...');

      this.SearchStatus = ("Updating Google search for lodging...");
      this.changeDetectorRef.detectChanges();
      //sleep: 2;
      setTimeout(function () { pagination.nextPage(); }, 2000);
    } else {
      console.log('Google search,')
      this.SearchStatus = ("Google search, " + ((this.nbrOfResults < 60) ? (" full set of " + this.nbrOfResults + " found ") : (" set of " + this.nbrOfResults + " shown")));
      this.changeDetectorRef.detectChanges();
    }
  }
  createMarker(place:google.maps.places.PlaceResult) {
    var placeLoc = place.geometry.location;
    var image = '../assets/mapbullet.png';
    var marker:google.maps.Marker = new google.maps.Marker({
      map: this.map,
      position: place.geometry.location,
      icon: image,
    });
    this.markerList.push(marker);
    google.maps.event.addListener(marker, 'click', () => {
      let markerContent = place.name + " " + place.vicinity;
      this.MapClicked((markerContent.trim().length>0)?markerContent:place.geometry.location.toUrlValue());
      //$("#AddressLine").val(place.geometry.location.toUrlValue());
      //infowindow.setContent(place.name + "\r\n" + place.vicinity + "\r\n" + place.geometry.location.toUrlValue() + "\r\n" + place.types.toString());
      this.infowindow.setContent(markerContent);
      this.infowindow.open(this.map, marker);
    });
  }
  OnMilesSearchChanged() {
    this.mapRadius = this.searchRadiusMiles;
    if (this.cityCircle != null) {
      let searchRadius = (this.searchPoint.Radius * 1609.34);
      let zoom = searchRadiusToGoogleZoom(searchRadius);
      //cityCircle = new google.maps.Circle(populationOptions);
      this.cityCircle.setRadius( searchRadius);
      this.cityCircle.setMap(null);
      this.cityCircle.setMap(this.map);
    }
  }
}


let zoomToSearchRadius = (googleZoom: number): number => {
  let cnvrt: number[] = [22];
  cnvrt[17] = 200;
  cnvrt[16] = 400;
  cnvrt[15] = 800;
  cnvrt[14] = 1600;
  cnvrt[13] = 3200;
  cnvrt[12] = 6400;
  cnvrt[11] = 12800;
  cnvrt[10] = 25600; //meters
  cnvrt[9] = 51200; //meters
  cnvrt[8] = 102400; //meters

  return cnvrt[googleZoom];
}

function searchRadiusToGoogleZoom(radiusInMeters) {
  let rtn = 8;
  for (let i = 8; i < 18; i++) {
    let m = zoomToSearchRadius(i);
    if (radiusInMeters > m)
      break;
    rtn = i;
  }
  return rtn;
}
